const zeroBasedMetric = (metricCode = "") =>
  /(^|_)(flow|pressure|water_level|level)($|_)/.test(metricCode);

const niceStep = (span, tickCount = 5) => {
  const roughStep = Math.abs(span) / tickCount;
  if (!Number.isFinite(roughStep) || roughStep === 0) return 1;

  const magnitude = 10 ** Math.floor(Math.log10(roughStep));
  const normalized = roughStep / magnitude;
  const multiplier = normalized <= 1
    ? 1
    : normalized <= 2
      ? 2
      : normalized <= 5
        ? 5
        : 10;
  return multiplier * magnitude;
};

const normalizeFloat = (value) => Number(value.toPrecision(12));

const niceDomain = (minimum, maximum) => {
  const step = niceStep(maximum - minimum);
  return [
    normalizeFloat(Math.floor(minimum / step) * step),
    normalizeFloat(Math.ceil(maximum / step) * step),
  ];
};

export const telemetryYDomain = (series = [], metricCode = "") => {
  const values = (Array.isArray(series) ? series : []).flatMap((item) =>
    (Array.isArray(item?.data) ? item.data : [])
      .map((point) => Number(point?.y))
      .filter(Number.isFinite)
  );

  if (values.length === 0) {
    return { min: "auto", max: "auto" };
  }

  const observedMin = Math.min(...values);
  const observedMax = Math.max(...values);

  if (zeroBasedMetric(metricCode) && observedMin >= 0) {
    const paddedMax = observedMax === 0 ? 1 : observedMax * 1.05;
    const [, max] = niceDomain(0, paddedMax);
    return { min: 0, max };
  }

  const span = observedMax - observedMin;
  const padding = span > 0
    ? span * 0.1
    : Math.max(Math.abs(observedMax) * 0.05, 1);
  const [min, max] = niceDomain(observedMin - padding, observedMax + padding);
  return { min, max };
};
